var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 10.6775C37.941 8.76256 34.0986 7.66699 30 7.66699C17.5734 7.66699 7.5 17.7404 7.5 30.167C7.5 42.5936 17.5734 52.667 30 52.667C42.4266 52.667 52.5 42.5936 52.5 30.167C52.5 25.3515 49.947 19.4795 48.411 17.2295M44.625 13.0495C45.0787 13.4341 45.5042 13.8261 45.9026 14.2221",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.166 39.8304L34.166 25.9748C34.166 25.5286 33.7463 25.167 33.2285 25.167L27.6036 25.167C27.0858 25.167 26.6661 25.5286 26.6661 25.9748L26.666 44.3592C26.666 44.8053 27.0857 45.167 27.6035 45.167H30.416M34.166 43.7931L34.166 44.3592",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5969 1.81887C24.549 1.93658 20.7206 2.88404 17.2699 4.4935C12.7376 6.60741 8.85688 9.86335 5.98639 13.8812M2.65813 19.9805C3.0099 19.0954 3.40439 18.2315 3.83913 17.3913",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6365 58.997C34.686 58.9731 38.5354 58.1146 42.0225 56.5855C46.6025 54.5771 50.5576 51.412 53.5204 47.4617M56.9891 41.4411C56.6169 42.3179 56.2025 43.1724 55.7484 44.0023",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.166 18.083C34.166 20.1541 32.4871 21.833 30.416 21.833C28.3449 21.833 26.666 20.1541 26.666 18.083C26.666 16.0119 28.3449 14.333 30.416 14.333C30.9133 14.333 31.388 14.4298 31.8223 14.6056",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.c0c469686d273d967677b84aa719bf4b.svg";
export { ForwardRef as ReactComponent };